import {Pipe, PipeTransform} from '@angular/core';

// https://auth0.com/blog/ionic-4-beta-whats-new-and-building-a-sample-app/

@Pipe({
  name: 'capitalize'
})
export class CapitalizePipe implements PipeTransform {

  consoleLog:boolean = false;

  transform(value: any, args?: any): any {
    return this.capitalize(value);
  }

  capitalize(string) 
  {
    //let returnString = string.toUpperCase(); 
    let returnString = string.charAt(0).toUpperCase() + string.slice(1);
    if (this.consoleLog) console.log("CapitalizePipe " + string + " -> " + returnString);
    return returnString;
    //return string.charAt(0).toUpperCase() + string.slice(1);
  }
}
